<template>
  <div v-if="courses.length > 0">
    <b-overlay :show="busy">
      <h4 class="m-3">
        <strong>{{ title }}</strong>
      </h4>
      <slot name="heading"></slot>
      <slot v-if="!$auth.auth" name="not-logged-in"></slot>
      <p v-if="courses && courses.length == 0">
        <slot name="empty"></slot>
      </p>
      <div v-else class="row g-3 ms-1">
        <div v-for="course in courses" :key="course.id" class="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-4">
          <CourseCardFull :columns="[6]" :course="course" :showProgress="showProgress" />
        </div>
      </div>
    </b-overlay>
    <div v-if="busy" class="text-center">
      <lottie-player
        autoplay
        loop
	      speed="2.5"
        src="/img/animations/custom_loader.json"
        style="height: 130px;"
        >
      </lottie-player>
    </div>
  </div>
</template>
<script>
import CourseCardFull from '@/views/courses/feed/views/card/CourseCardFull.vue';

export default {
  components: {
    CourseCardFull,
  },
  props: {
    courses: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    busy: {
      type: Boolean,
      default: true,
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
